
export const PROJECTS = 'projects';

export const PROJECT_ACTION_TYPES = {
  CREATE_PROJECT: `${PROJECTS}/CREATE_PROJECT`,
  RECEIVE_PROJECT: `${PROJECTS}/RECEIVE_PROJECT`,
  RECEIVE_PROJECTS: `${PROJECTS}/RECEIVE_PROJECTS`,
  FETCH_PROJECTS: `${PROJECTS}/FETCH_PROJECTS`,
  RECEIVE_ACTIVE_PROJECT: `${PROJECTS}/RECEIVE_ACTIVE_PROJECT`,
  TOGGLE_NOTIFICATIONS: `${PROJECTS}/TOGGLE_NOTIFICATIONS`,
  RECEIVE_TOGGLED_NOTIFICATIONS: `${PROJECTS}/RECEIVE_TOGGLED_NOTIFICATIONS`,
  UPDATE_PROJECT: `${PROJECTS}/UPDATE_PROJECT`,
  RECEIVE_UPDATED_PROJECT: `${PROJECTS}/RECEIVE_UPDATED_PROJECT`,
  DELETE_PROJECT:  `${PROJECTS}/DELETE_PROJECT`,
  DELETE_COLLABORATOR: `${PROJECTS}/DELETE_COLLABORATOR`,
  RECEIVE_DELETED_PROJECT: `${PROJECTS}/RECEIVE_DELETED_PROJECT`
};



// WEBPACK FOOTER //
// ./src/redux/projects/constants.js